import { render, staticRenderFns } from "./cooperation-pay-detail.vue?vue&type=template&id=4fe240bc&scoped=true&"
import script from "./cooperation-pay-detail.vue?vue&type=script&lang=js&"
export * from "./cooperation-pay-detail.vue?vue&type=script&lang=js&"
import style0 from "./cooperation-pay-detail.vue?vue&type=style&index=0&id=4fe240bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe240bc",
  null
  
)

export default component.exports